import { DragEvent, useState } from 'react';

export type ImageDropZoneHandlers = {
  onDragOver: (e: DragEvent<HTMLElement>) => void;
  onDragLeave: (e: DragEvent<HTMLElement>) => void;
  onDrop: (e: DragEvent<HTMLElement>) => void;
};

export type UseImageDropZoneResult = {
  isDragOver: boolean;
  dragHandlers: ImageDropZoneHandlers;
};

type ImageDropZoneOptions = {
  onReject?: (file: File) => void;
};

export const useImageDropZone = (
  onFile: (file: File) => void,
  options?: ImageDropZoneOptions,
): UseImageDropZoneResult => {
  const [isDragOver, setIsDragOver] = useState(false);

  const onDragOver = (e: DragEvent<HTMLElement>) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const onDragLeave = (e: DragEvent<HTMLElement>) => {
    if (!e.currentTarget.contains(e.relatedTarget as Node)) {
      setIsDragOver(false);
    }
  };

  const onDrop = (e: DragEvent<HTMLElement>) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = Array.from(e.dataTransfer.files ?? []);
    for (const file of files) {
      if (file.type.startsWith('image/')) {
        onFile(file);
      } else {
        options?.onReject?.(file);
      }
    }
  };

  return { isDragOver, dragHandlers: { onDragOver, onDragLeave, onDrop } };
};
